import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:3100";

export async function fetchApprovalList(
  token,
  { type = "all", listMode = "pending", pageSize = 100, page = 1, status, stage } = {},
) {
  const res = await axios.get(`${API_URL}/api/approvals`, {
    headers: { Authorization: `Bearer ${token}` },
    params: {
      type,
      listMode,
      pageSize,
      page,
      ...(status ? { status } : {}),
      ...(stage ? { stage } : {}),
    },
  });

  return {
    items: Array.isArray(res.data?.items) ? res.data.items : [],
    total: res.data?.total ?? 0,
  };
}

/** @deprecated use fetchApprovalList */
export async function fetchApprovalQueue(token, type = "all", params = {}) {
  return fetchApprovalList(token, { type, listMode: "pending", ...params });
}

export async function fetchPendingApprovalCount(token) {
  const res = await axios.get(`${API_URL}/api/approvals/count`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data?.count ?? 0;
}
